function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m 19.839241,11.395144 c 0,-4.5672476 3.702518,-8.2697747 8.269776,-8.2697747 4.567258,0 8.269776,3.7025271 8.269776,8.2697747 0,4.567248 -3.702518,8.269776 -8.269776,8.269776 -4.567258,0 -8.269776,-3.702528 -8.269776,-8.269776 z",
  fillRule: "evenodd",
  id: "path170",
  fill: "none",
  strokeWidth: 3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M 19.839,28.769775 C 19.839,24.202527 23.541518,20.5 28.108776,20.5 c 4.567258,0 8.269776,3.702527 8.269776,8.269775 0,4.567248 -3.702518,8.269776 -8.269776,8.269776 -4.567258,0 -8.269776,-3.702528 -8.269776,-8.269776 z",
  fillRule: "evenodd",
  id: "path170-0",
  fill: "none",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m 19.839,46.52841 c 0,-4.567248 3.702518,-8.269775 8.269776,-8.269775 4.567259,0 8.269776,3.702527 8.269776,8.269775 0,4.567248 -3.702517,8.269776 -8.269776,8.269776 -4.567258,0 -8.269776,-3.702528 -8.269776,-8.269776 z",
  fillRule: "evenodd",
  id: "path170-0-6",
  fill: "none",
  strokeWidth: 3
});

function SvgTrafficsignal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56.9 56.9",
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficsignal);
export default __webpack_public_path__ + "static/media/trafficsignal.a7975d46.svg";
export { ForwardRef as ReactComponent };